import React from "react";
import PropTypes from "prop-types";
const CaretSlimIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title,
  direction = "up"
}) => {
  const directionToAngle = {
    up: 0,
    right: 90,
    down: 180,
    left: -90
  };

  const finalStyle = {
    transform: `rotate(${directionToAngle[direction]}deg)`,
    ...style
  };

  return (
    <svg
      className={className}
      style={finalStyle}
      data-no-pointer={noPointer}
      width={width || size || 24}
      height={height || size || 24}
      viewBox="0 0 14 8"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
      data-testid="CaretSlimIcon"
    >
      <title>{title}</title>
      <g fill="none" fillRule="evenodd">
        <path d="M-5 16h24V-8H-5z" />
        <path
          fill={color || "var(--color-easil-gray-x-dark)"}
          fillRule="nonzero"
          d="M12.293 7.707a1 1 0 0 0 1.414-1.414l-6-6a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 1.414 1.414L7 2.414l5.293 5.293z"
        />
      </g>
    </svg>
  );
};

CaretSlimIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  color: PropTypes.string
};

export default CaretSlimIcon;
